/* ============================================================
   Five Origins, filtrare de colectie si selectie de gramaj.
   Portare a motorului de la ONE COFFEE (assets/one-collection.js).

   Filtrele nu mai sunt scrise in cod. Fiecare casuta poarta
   data-facet (numele grupului) si value (handle-ul metaobiectului),
   iar cardurile poarta data-<grup> cu handle-urile lor. Un grup nou
   adaugat in taxonomie functioneaza fara nicio modificare aici.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.foInit === '1') return;
    root.dataset.foInit = '1';

    var grid = root.querySelector('[data-fo-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-fo-card]'));
    var titluri = Array.prototype.slice.call(grid.querySelectorAll('[data-fo-group]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
    var segments = Array.prototype.slice.call(root.querySelectorAll('[data-segment]'));
    var countEl = root.querySelector('[data-fo-count]');
    var emptyEl = root.querySelector('[data-fo-empty]');
    var activeBox = root.querySelector('[data-fo-active]');
    var activeText = root.querySelector('[data-fo-active-text]');
    var resetBtn = root.querySelector('[data-fo-reset]');

    var forcedSegment = null;
    var lots = Array.prototype.slice.call(root.querySelectorAll('[data-fo-lot]'));
    var forcedLot = null;
    var contoare = [];

    function tokens(card, facet) {
      var raw = card.dataset[facet] || '';
      return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function selected() {
      var groups = {};
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var facet = input.dataset.facet;
        (groups[facet] = groups[facet] || []).push(input.value);
      });
      return groups;
    }

    function labels() {
      return inputs
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.dataset.label || i.value; });
    }

    function apply() {
      var groups = selected();
      var facets = Object.keys(groups);
      var shown = 0;

      cards.forEach(function (card) {
        var visible = true;

        if (forcedSegment && forcedSegment !== 'all') {
          if ((card.dataset.usage || '') !== forcedSegment) visible = false;
        }

        if (forcedLot && (card.dataset.lot || '') !== forcedLot) visible = false;

        for (var i = 0; i < facets.length && visible; i++) {
          var facet = facets[i];
          var wanted = groups[facet];
          var has = tokens(card, facet);
          var match = wanted.some(function (w) { return has.indexOf(w) > -1; });
          if (!match) visible = false;
        }

        card.hidden = !visible;
        if (visible) shown++;
      });

      /* Titlul unui grup („Echipamente", „Consumabile si accesorii") dispare
         cand filtrele ii golesc randul. Cardurile unui grup sunt fratii care
         urmeaza titlul pana la urmatorul titlu, deci nu e nevoie de niciun
         atribut nou in card. */
      titluri.forEach(function (titlu) {
        var el = titlu.nextElementSibling;
        var areCeva = false;
        while (el && !el.hasAttribute('data-fo-group')) {
          if (el.hasAttribute('data-fo-card') && !el.hidden) { areCeva = true; break; }
          el = el.nextElementSibling;
        }
        titlu.hidden = !areCeva;
      });

      contoare.forEach(function (fn) { fn(); });

      /* Poza pe numar de grupuri: cand e bifat un singur numar, cardurile care
         au poza lui (data-img-g2, data-img-g3) o arata; altfel revin la poza
         lor. */
      var gr = groups.grupuri && groups.grupuri.length === 1 ? groups.grupuri[0] : null;
      cards.forEach(function (card) {
        var img = card.querySelector('.fo-card__media img');
        if (!img) return;
        var alt = gr ? card.getAttribute('data-img-g' + gr) : null;
        if (alt) {
          if (!img.dataset.origSrc) {
            img.dataset.origSrc = img.getAttribute('src');
            img.dataset.origSrcset = img.getAttribute('srcset') || '';
          }
          img.removeAttribute('srcset');
          img.setAttribute('src', alt);
        } else if (img.dataset.origSrc) {
          img.setAttribute('src', img.dataset.origSrc);
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
          delete img.dataset.origSrc;
          delete img.dataset.origSrcset;
        }
      });

      if (countEl) countEl.textContent = shown === 1 ? '1 produs' : shown + ' produse';
      if (emptyEl) emptyEl.hidden = shown !== 0;

      var active = labels();
      if (activeBox) {
        if (active.length) {
          activeBox.hidden = false;
          if (activeText) activeText.textContent = 'Filtrat după: ' + active.join(', ');
        } else {
          activeBox.hidden = true;
        }
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', apply); });

    segments.forEach(function (btn) {
      btn.addEventListener('click', function () {
        segments.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        forcedSegment = btn.dataset.segment;
        apply();
      });
    });

    /* Selectorul de lot: un clic arata doar grupul ales, al doilea clic pe
       acelasi buton arata iar tot. Alegerea se pastreaza in adresa (?lot=),
       ca linkul copiat sa deschida pagina la fel. */
    function setLot(value) {
      forcedLot = value || null;
      lots.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.foLot === forcedLot ? 'true' : 'false');
      });
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        if (forcedLot) u.searchParams.set('lot', forcedLot); else u.searchParams.delete('lot');
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      }
    }

    lots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLot(forcedLot === btn.dataset.foLot ? null : btn.dataset.foLot);
        apply();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function (event) {
        event.preventDefault();
        inputs.forEach(function (i) { i.checked = false; });
        apply();
      });
    }

    /* Preselectie din URL: ?metoda=filtru&gust=fructat
       Acceptam si formatul Shopify filter.p.m.coffee.<grup>=<handle>. */
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      var facet = key;
      var prefix = 'filter.p.m.coffee.';
      if (key.indexOf(prefix) === 0) facet = key.slice(prefix.length);
      value.split(',').forEach(function (v) {
        var match = inputs.filter(function (i) {
          return i.dataset.facet === facet && i.value === v.trim();
        })[0];
        if (match) match.checked = true;
      });
    });

    /* Filtrele ca acordeon. Titlul fiecarui grup devine buton; bifele nu se
       schimba, doar se ascund, deci filtrarea merge exact ca inainte.
       Pe desktop pornesc deschise Disponibilitate si Metoda, pe telefon
       toate inchise. Un grup cu o bifa activa (si din link) sta deschis, iar
       titlul arata cate bife are active, ca nimic sa nu filtreze nevazut. */
    var facetsBox = root.querySelector('.fo-facets');
    if (facetsBox && !facetsBox.classList.contains('fo-facets--acordeon')) {
      var mobil = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
      facetsBox.classList.add('fo-facets--acordeon');
      var setari = [];
      Array.prototype.forEach.call(facetsBox.querySelectorAll('.fo-facet'), function (fs, idx) {
        var legend = fs.querySelector('.fo-facet__title');
        var list = fs.querySelector('.fo-facet__list');
        if (!legend || !list) return;

        var grupuri = Array.prototype.map.call(fs.querySelectorAll('[data-facet]'), function (x) { return x.dataset.facet; });
        var deschis = !mobil && grupuri.some(function (g) { return g === 'disponibil' || g === 'metoda' || g === 'familie'; });
        if (fs.querySelector('[data-facet]:checked')) deschis = true;

        if (!list.id) list.id = 'fo-facet-' + idx + '-' + Math.random().toString(36).slice(2, 7);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fo-facet__toggle';
        btn.setAttribute('aria-controls', list.id);
        var eticheta = document.createElement('span');
        eticheta.textContent = legend.textContent.trim();
        var nr = document.createElement('span');
        nr.className = 'fo-facet__count';
        btn.appendChild(eticheta);
        btn.appendChild(nr);
        btn.insertAdjacentHTML('beforeend', '<svg class="fo-facet__chev" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 3.5 5 7l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        legend.textContent = '';
        legend.appendChild(btn);

        function seteaza(open) {
          fs.classList.toggle('is-closed', !open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        seteaza(deschis);
        setari.push({ fn: seteaza, open: deschis });
        btn.addEventListener('click', function () { seteaza(fs.classList.contains('is-closed')); });

        contoare.push(function () {
          var n = fs.querySelectorAll('[data-facet]:checked').length;
          nr.textContent = n ? '(' + n + ')' : '';
        });
      });
      /* Colectiile fara Disponibilitate sau Metoda (echipamente, ceai):
         pe desktop macar primul grup porneste deschis. */
      if (!mobil && setari.length && !setari.some(function (s) { return s.open; })) setari[0].fn(true);
    }

    var lotParam = params.get('lot');
    if (lotParam && lots.some(function (b) { return b.dataset.foLot === lotParam; })) {
      forcedLot = lotParam;
      lots.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.foLot === lotParam ? 'true' : 'false');
      });
    }

    apply();
  }

  function initSizes(scope) {
    scope.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-fo-size]') : null;
      if (!btn) return;
      var card = btn.closest('[data-fo-card]');
      if (!card) return;

      card.querySelectorAll('[data-fo-size]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      var input = card.querySelector('[data-fo-variant-input]');
      if (input) input.value = btn.dataset.variant;

      /* cafeaua cu macinare aleasa pe pagina: linkul duce la gramajul ales */
      var choose = card.querySelector('[data-fo-choose]');
      if (choose) {
        var url = new URL(choose.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', btn.dataset.variant);
        choose.setAttribute('href', url.pathname + url.search);
      }

      var price = card.querySelector('[data-fo-price]');
      if (price && btn.dataset.price) price.textContent = btn.dataset.price;
    });
  }

  function boot() {
    document.querySelectorAll('[data-fo-collection]').forEach(init);
    initSizes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-fo-collection]').forEach(init);
  });
})();
